const doc = [({"ja":({"adminButtonCompany":({"updateCreditCardFees":"決済手数料を更新する", "updateSystemUsageFees":"システム利用料を更新する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;